// extracted by mini-css-extract-plugin
export default {"imageWidth":"Notfound_imageWidth__4KGLx"};